/* import __COLOCATED_TEMPLATE__ from './dac-type.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();